import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY } from "../colors";

const REVIEWS = [
  { stars: 5, text: "Best pizza in Brooklyn!", time: "2m ago" },
  { stars: 4, text: "Great crust, friendly staff", time: "1h ago" },
  { stars: 5, text: "Our favorite spot in Park Slope!", time: "3h ago" },
];

export const AiMonitorsAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const panelAppear = spring({ frame, fps, config: { damping: 14 } });
  const scanLineY = interpolate(frame, [20, 100], [0, 220], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const scanOpacity = frame >= 20 && frame <= 105 ? 0.6 : 0;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        justifyContent: "center",
        alignItems: "center",
        padding: 30,
      }}
    >
      <div
        style={{
          transform: `scale(${panelAppear})`,
          opacity: panelAppear,
          width: "100%",
          maxWidth: 480,
          backgroundColor: "white",
          borderRadius: 20,
          padding: 24,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${BRAND[400]}, ${BRAND[600]})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ fontSize: 18, color: "white" }}>✦</span>
          </div>
          <div>
            <div style={{ fontSize: 19, fontWeight: 700, color: GRAY[800] }}>AI Monitor</div>
            <div style={{ fontSize: 15, color: BRAND[500] }}>
              {frame > 30 ? "Scanning reviews..." : "Starting scan"}
            </div>
          </div>
          <div
            style={{
              marginLeft: "auto",
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: frame > 20 ? BRAND[500] : GRAY[300],
              boxShadow: frame > 20 ? `0 0 10px ${BRAND[400]}` : "none",
            }}
          />
        </div>

        {/* Review list */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10, position: "relative" }}>
          {REVIEWS.map((review, i) => {
            const cardFrame = frame - 25 - i * 18;
            const cardAppear = spring({ frame: cardFrame, fps, config: { damping: 14 } });
            const isScanned = cardFrame > 20;

            return (
              <div
                key={review.text}
                style={{
                  opacity: cardAppear,
                  transform: `translateX(${interpolate(cardAppear, [0, 1], [20, 0])}px)`,
                  backgroundColor: isScanned ? BRAND[50] : GRAY[50],
                  borderRadius: 12,
                  padding: "14px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: `1px solid ${isScanned ? BRAND[200] : GRAY[200]}`,
                }}
              >
                <div>
                  <div style={{ fontSize: 16, color: "#F59E0B", letterSpacing: 1 }}>
                    {"★".repeat(review.stars)}
                    {"☆".repeat(5 - review.stars)}
                  </div>
                  <div style={{ fontSize: 16, color: GRAY[700], marginTop: 4 }}>{review.text}</div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                  <div style={{ fontSize: 13, color: GRAY[400] }}>{review.time}</div>
                  {isScanned && (
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: BRAND[600],
                        backgroundColor: BRAND[100],
                        padding: "2px 10px",
                        borderRadius: 8,
                      }}
                    >
                      ✦ Reply ready
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          {/* Scan line */}
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: scanLineY,
              height: 2,
              background: `linear-gradient(90deg, transparent, ${BRAND[400]}, transparent)`,
              opacity: scanOpacity,
            }}
          />
        </div>
      </div>
    </AbsoluteFill>
  );
};
